import React from 'react';
import t from 'tcomb-form';
import {connect} from 'react-redux';
import * as DocumentStorageActions from '../../actions/documentStorage';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as AppActions from '../../actions/app';

const Form = t.form.Form;

const Settings = t.struct({
    title: t.String,
    memo: t.maybe(t.String),
    authorId: t.String,
});

class FormSettings extends React.Component {

    constructor(props, context) {
        super(props, context);

        const {app, user, ConfiguratorManager} = props;
        const organisationUsers = app.organisationUsers;
        let formValues = {
            title: ConfiguratorManager.getDocumentStorageTitle(),
            memo: ConfiguratorManager.getDocumentStorageMemo(),
        };
        let formOptions = {
            fields: {
                title: {
                    label: this.props.intl.formatMessage({id: 'LABEL_TITLE'}),
                },
                memo: {
                    label: this.props.intl.formatMessage({id: 'LABEL_MEMO'}),
                    type: 'textarea',
                    rows: 5
                },
                authorId: {
                    label: this.props.intl.formatMessage({id: 'LABEL_AUTHORS'}),
                    factory: t.form.Select,
                    options: [],
                    nullOption: false,
              }
            }
        };
        let formSettings = {
            title: t.String,
            memo: t.maybe(t.String),
        };

        // set form field to change the author of the storage
        if (user.rightChangeDocumentStorageUser &&
            organisationUsers && organisationUsers instanceof Array && organisationUsers.length) {
            let selectedUsers = [];
            organisationUsers.map(user => {
                selectedUsers.push({
                    value: user.id,
                  text: user.usernameCanonical
                })
            });
            formValues.authorId = ConfiguratorManager.getAuthorId();
            formSettings.authorId = t.String;
            formOptions.fields.authorId.options = selectedUsers;
        }
        this.state = {
            formValues: formValues,
            formSettings: t.struct(formSettings),
            formOptions: formOptions,
        };

        this.save = this.save.bind(this);
    }

    componentWillMount() {
        let {dispatch} = this.props;
        dispatch(AppActions.getOrganisationUsers());
    }

    componentWillReceiveProps(nextProps) {

      const {app, user, ConfiguratorManager} = nextProps;
      const organisationUsers = app.organisationUsers;
      if (user.rightChangeDocumentStorageUser &&
        organisationUsers && organisationUsers instanceof Array && organisationUsers.length) {

        let selectedUsers = [];
        organisationUsers.map(user => {
          selectedUsers.push({
            value: user.id,
            text: user.usernameCanonical
          })
        });

        const formSettings = t.struct({
          title: t.String,
          memo: t.maybe(t.String),
          authorId: t.String
        });

        const formValues = t.update(this.state.formValues, {
          authorId: {'$set': ConfiguratorManager.getAuthorId()}
        });

        const formOptions = t.update(this.state.formOptions, {
          fields: {
            authorId: {
              options: {'$set': selectedUsers}
            }
          }
        });

        this.setState({
            formValues: formValues,
            formSettings: formSettings,
            formOptions: formOptions,
          }
        );
      }

    }

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    save(event) {

        event.preventDefault();

        const {ConfiguratorManager, dispatch, user} = this.props;

        // call getValue() to get the values of the form
        const formValues = this.refs.form.getValue();

        // if validation fails, value will be null
        if (formValues) {
            const title = formValues.title;
            const memo = formValues.memo === null ? '' : formValues.memo;
            const authorId = formValues.authorId;

            const newState = {
                ...this.state,
                formValues: {
                    title: title,
                    memo: memo,
                    authorId: authorId
                }
            };

            this.setState(newState,
                function () {
                    // update title and memo
                    dispatch(DocumentStorageActions.updateDocumentStorage(ConfiguratorManager.getStorageId(), title, null, null, memo, authorId));
                }
            );
        }
    }

    render() {
        return (
            <div>
                <form onSubmit={event => this.save(event)}>
                    <Form
                        ref="form"
                        type={this.state.formSettings}
                        value={this.state.formValues}
                        options={this.state.formOptions}
                    />
                    <button type="button" className="btn btn-success btn-block" onClick={event => this.save(event)}>
                        <i className="material-icons">save</i><FormattedMessage id="LABEL_SAVE" />
                    </button>
                </form>
            </div>
        );
    }
}

export default connect(state => ({ user: state.user, app: state.app }))(injectIntl(FormSettings));



// WEBPACK FOOTER //
// ./src/js/components/forms/FormSettings.react.jsx